import { nanoid } from 'nanoid'

export const getSurchargeSettingsList = (restaurant) => {
    if (restaurant && restaurant.surchargeSettings) {
      return  restaurant.surchargeSettings;
    }
    if (restaurant && restaurant.holidaySurcharge) {
      return [{
        publicHolidayDays: restaurant.holidaySurcharge.publicHolidayDays,
        weekdays: restaurant.holidaySurcharge.weekdays,
        isEnabled: restaurant.holidaySurcharge.isEnabled,
        isPercentage: restaurant.holidaySurcharge.isPercentage,
        amount: restaurant.holidaySurcharge.amount,
        name: "Holiday/weekend Surcharge",
        surchargeDescription: "Holiday/weekend Surcharge",
        id: 'holidaySurcharge',
      }];
    }
    return [];
 } 


// Optional per-weekday surcharge hours (OA-1646), saved as
// weekdayHours: { Sunday: { startTime: "17:00", endTime: "02:00" } }.
// A selected day without hours applies all day, as before. An end time earlier
// than the start time carries the window past midnight into the next day.
const SURCHARGE_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export const hasSurchargeHours = (hours) =>
  Boolean(hours && hours.startTime && hours.endTime);

export const isOvernightSurcharge = (hours) =>
  hasSurchargeHours(hours) && hours.endTime < hours.startTime;

export const getSurchargeHoursError = (hours) => {
  if (!hours) {
    return null;
  }
  const { startTime, endTime } = hours;
  if (!startTime || !endTime) {
    return 'Enter both a start and end time';
  }
  if (!SURCHARGE_TIME_PATTERN.test(startTime) || !SURCHARGE_TIME_PATTERN.test(endTime)) {
    return 'Times must be in HH:mm format';
  }
  if (startTime === endTime) {
    return 'End time must be different from start time';
  }
  return null;
};

export const buildWeekdayHours = (weekdays, weekdayHours) => {
  const picked = {};
  weekdays.forEach((day) => {
    const hours = weekdayHours && weekdayHours[day];
    if (hours) {
      picked[day] = { startTime: hours.startTime, endTime: hours.endTime };
    }
  });
  return Object.keys(picked).length > 0 ? { weekdayHours: picked } : {};
};

// "17:00" -> "5:00 PM", matching how the time pickers show it.
export const formatTime12 = (time) => {
  const [hours, minutes] = time.split(':').map(Number);
  const suffix = hours < 12 ? 'AM' : 'PM';
  return `${hours % 12 || 12}:${String(minutes).padStart(2, '0')} ${suffix}`;
};

export const formatSurchargeHours = (hours) => {
  if (!hasSurchargeHours(hours)) {
    return '';
  }
  const nextDay = isOvernightSurcharge(hours) ? ' (next day)' : '';
  return `${formatTime12(hours.startTime)} – ${formatTime12(hours.endTime)}${nextDay}`;
};

export const timeStringToDate = (time) => {
  if (!time || !SURCHARGE_TIME_PATTERN.test(time)) {
    return null;
  }
  const [hours, minutes] = time.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
};

const pad = (n) => String(n).padStart(2, '0');

export const dateToTimeString = (date) =>
  date instanceof Date && !isNaN(date.getTime())
    ? `${pad(date.getHours())}:${pad(date.getMinutes())}`
    : '';
